import { render, staticRenderFns } from "./FormFieldTimeInMinutes.vue?vue&type=template&id=4a59e6a5&scoped=true&"
import script from "./FormFieldTimeInMinutes.vue?vue&type=script&lang=js&"
export * from "./FormFieldTimeInMinutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a59e6a5",
  null
  
)

export default component.exports